import styled from "styled-components";
import { ArrowUp, ArrowDown } from '../../../icons'

export const HeaderGrid = styled.div`
  display: flex;
  align-items: center;
  height: 56px;
  margin-bottom: -15px;
  min-width: max-content;

  background-color: ${({ theme }) => theme.old.colors.gray[900]};
  color: ${({ theme }) => theme.old.colors.gray[450]};
  font-size: ${({ theme }) => theme.old.fonts.size.smaller};
  font-weight: ${({ theme }) => theme.old.fonts.weight.semibold};
  padding-right: 50px;

  &:first-child {
    padding-left: 24px;
  }

  &:last-child {
    padding-right: 24px;
  }
`

export const ArrowsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 6px;
`

export const ArrowAsc = styled(ArrowUp)`
  height: 9px;
  width: 10px;
  color: ${({ $isActive, theme }) => $isActive
    ? theme.old.colors.primary
    : theme.old.colors.gray[625]
  };
`

export const ArrowDes = styled(ArrowDown)`
  height: 9px;
  width: 10px;
  color: ${({ $isActive, theme }) => $isActive
    ? theme.old.colors.primary
    : theme.old.colors.gray[625]
  }
`

export const HeaderBtn = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  color: inherit;
  font-size: inherit;
  font-weight: inherit;
  display: flex;
  align-items: center;
`